import {NgModule, APP_INITIALIZER} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {CoreService} from "./core.service";
import {HttpClientService} from "./http-client.service";
import {NotificationService} from "./notification.service";
import {AccentService} from "./accent.service";
import {UserProfileService} from "./user-profile.service";
import {CacheStorageService} from "./cache-storage.service";
import {RoleAccessDirective} from "./role-access.directive";
import {InfiniteScrollerDirective} from "./infinite-scroller.directive";
import {AutoSizeDirective} from "./autosize.directive";
import {AvatarDirective} from "./avatar.directive";
import {SecurityService} from "./security.service";
import {SSOUrlPipe} from "./ssourl.pipe";
import {ResourceLoaderService} from "./resource-loader.service";
import {initApp} from "./init-app";
import {LoadingIndicatorService} from "./loading-indicator.service";

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule
    ],
    declarations: [
        RoleAccessDirective,
        InfiniteScrollerDirective,
        AutoSizeDirective,
        AvatarDirective,
        SSOUrlPipe
    ],
    exports: [
        RoleAccessDirective,
        InfiniteScrollerDirective,
        AutoSizeDirective,
        AvatarDirective,
        SSOUrlPipe
    ],
    providers: [
        CoreService,
        HttpClientService,
        NotificationService,
        AccentService,
        UserProfileService,
        CacheStorageService,
        ResourceLoaderService,
        {
            'provide': APP_INITIALIZER,
            'useFactory': initApp,
            'multi': true,
            'deps': [SecurityService]
        },
        SecurityService,
        LoadingIndicatorService
    ]
})
export class CoreModule {
}
